export default __webpack_public_path__ + "static/media/login-bg.100bfe0b.svg";